import API from '../config/axios'

const versionAPI = {
	getVersion: async () => {
		const res = await API.get('/version')

		if (res) {
			if (res.status === 200) {
				return res
			} else {
				console.error(res)
				return false
			}
		}
	},
}

export default versionAPI
